var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "folder_15147765",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.064,
    height: 28.255,
    viewBox: "0 0 27.064 28.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_184779",
    "data-name": "Group 184779",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63331",
    "data-name": "Path 63331",
    d: "M120.058,20.975v16.5a2.781,2.781,0,0,1-2.781,2.782H100.128a2.781,2.781,0,0,1-2.781-2.782V14.782A2.781,2.781,0,0,1,100.128,12h11.486Z",
    transform: "translate(-92.994 -12)",
    fill: "#f9a64b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63332",
    "data-name": "Path 63332",
    d: "M352.292,20.99h-6.6a1.857,1.857,0,0,1-1.857-1.857V12Z",
    transform: "translate(-325.228 -12.001)",
    fill: "#ff6f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63333",
    "data-name": "Path 63333",
    d: "M44.357,251.711H22.819a.534.534,0,0,1-.534-.534v-9.761a.534.534,0,0,1,.534-.534H44.357a.534.534,0,0,1,.534.534v9.761A.534.534,0,0,1,44.357,251.711Z",
    transform: "translate(-22.285 -227.655)",
    fill: "#ff6f01"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_184778",
    "data-name": "Group 184778",
    transform: "translate(4.888 15.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63334",
    "data-name": "Path 63334",
    d: "M108.6,290.328a2.228,2.228,0,0,1-.921-.183,1.468,1.468,0,0,1-.631-.519,1.375,1.375,0,0,1-.227-.787.394.394,0,0,1,.105-.317.5.5,0,0,1,.308-.08.634.634,0,0,1,.285.058.228.228,0,0,1,.129.214,1.114,1.114,0,0,0,.1.428.737.737,0,0,0,.3.328.988.988,0,0,0,.524.125.927.927,0,0,0,.689-.247,1.03,1.03,0,0,0,.247-.76v-3.276h-.914a.222.222,0,0,1-.2-.114.477.477,0,0,1-.071-.261.5.5,0,0,1,.062-.241.221.221,0,0,1,.21-.118h1.366a.478.478,0,0,1,.261.073.22.22,0,0,1,.114.2v3.737a1.92,1.92,0,0,1-.234,1.014,1.371,1.371,0,0,1-.626.555A2.139,2.139,0,0,1,108.6,290.328Z",
    transform: "translate(-106.823 -284.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63335",
    "data-name": "Path 63335",
    d: "M185,290.282a.615.615,0,0,1-.285-.065.218.218,0,0,1-.129-.207v-5.164a.234.234,0,0,1,.089-.187.339.339,0,0,1,.23-.08h1.522a2.185,2.185,0,0,1,.865.169,1.3,1.3,0,0,1,.617.546,1.947,1.947,0,0,1,.227,1v.062a1.892,1.892,0,0,1-.234,1,1.359,1.359,0,0,1-.633.55,2.219,2.219,0,0,1-.889.172h-.967v1.926a.218.218,0,0,1-.129.207A.625.625,0,0,1,185,290.282Zm.414-2.855h.967a.916.916,0,0,0,.682-.248,1.048,1.048,0,0,0,.247-.764v-.094a1.032,1.032,0,0,0-.247-.762.921.921,0,0,0-.682-.245h-.967Z",
    transform: "translate(-180.073 -284.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63336",
    "data-name": "Path 63336",
    d: "M258.833,290.329a2.212,2.212,0,0,1-.892-.171,1.341,1.341,0,0,1-.624-.555,1.939,1.939,0,0,1-.23-1.014V286.32a1.955,1.955,0,0,1,.23-1.016,1.336,1.336,0,0,1,.624-.553,2.146,2.146,0,0,1,.869-.172,2.237,2.237,0,0,1,.929.181,1.507,1.507,0,0,1,.624.5,1.289,1.289,0,0,1,.227.764.387.387,0,0,1-.105.316.5.5,0,0,1-.308.083.66.66,0,0,1-.285-.058.233.233,0,0,1-.129-.216,1.41,1.41,0,0,0-.109-.417.656.656,0,0,0-.281-.3,1.072,1.072,0,0,0-.539-.114.923.923,0,0,0-.682.245,1.032,1.032,0,0,0-.247.762v2.269a1.03,1.03,0,0,0,.247.76,1.061,1.061,0,0,0,1.36,0,1.023,1.023,0,0,0,.25-.76v-.64h-.787a.223.223,0,0,1-.2-.1.4.4,0,0,1,0-.455.222.222,0,0,1,.2-.105h1.34a.253.253,0,0,1,.2.082.3.3,0,0,1,.071.2v1.021a1.92,1.92,0,0,1-.234,1.014,1.361,1.361,0,0,1-.633.555,2.219,2.219,0,0,1-.889.17Z",
    transform: "translate(-248.372 -284.579)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpeg);
export default __webpack_public_path__ + "static/media/jpeg.03b71c5066eb87c4142c1bfa233e88a7.svg";
export { ForwardRef as ReactComponent };